<template>
    <sales-period-form
        :project="project"
        :teams="teams"
        :errors="errors"
        :products="products"
        :loading="loading"
        :available-sales-managers="availableSalesManagers"
        :initial-selected-sales-manager="initialSelectedSalesManager"
        @save="save"
    />
</template>

<script>
    import SalesPeriodForm from './Partials/SalesPeriodForm';

    export default {
        components: { SalesPeriodForm },
        props: {
            project: {
                required: true,
                type: Object,
            },
            products: {
                required: true,
                type: Array,
            },
            teams: {
                required: true,
                type: Array,
            },
            initialSelectedSalesManager: {
                required: false,
                type: Number,
                default: null,
            },
            availableSalesManagers: {
                required: true,
                type: Object,
            },
        },

        data() {
            return {
                errors: null,
                loading: false,
            };
        },

        methods: {
            async save(salesPeriod, addUnsignedAddresses) {
                this.errors = null;
                this.loading = true;

                try {
                    const { data } = await axios.post(route('admin.sales-projects.sales-periods.store', this.project), {
                        salesPeriod,
                        add_unsigned_addresses: addUnsignedAddresses,
                    });

                    if (! addUnsignedAddresses) {
                        window.location.href = route('admin.sales-projects.sales-periods.unsigned-addresses.create', [
                            this.project.id,
                            data.salesPeriod.id,
                        ]);

                        return;
                    }

                    window.location.href = route('admin.sales-projects.sales-periods.index', this.project);
                } catch (error) {
                    if (error.response.status === 422) {
                        flash_error('Formuläret är inte korrekt ifyllt');
                        this.errors = error.response.data.errors;
                    } else {
                        flash_error('Säljomgången kunde inte skapas.');
                    }

                    this.loading = false;
                }
            },
        },
    };
</script>
